import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { type Station } from '../../shared/types';
import { getStations } from '../utilities/api';

export const queryKeys = {
    getStations: () => ['stations', 'get'],
};

export const useStations = (): UseQueryResult<Station[], Error> => {
    return useQuery({ queryKey: queryKeys.getStations(), queryFn: getStations, retry: false });
};
